import { render } from "./OrdersPage.vue?vue&type=template&id=627d375a&ts=true"
import script from "./OrdersPage.vue?vue&type=script&lang=ts"
export * from "./OrdersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__